"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("../../Button"));

var _ = require("../../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formButton = function formButton(_ref) {
  var _ref$buttonClickHandl = _ref.buttonClickHandler,
      buttonClickHandler = _ref$buttonClickHandl === void 0 ? function () {
    return null;
  } : _ref$buttonClickHandl,
      disabled = _ref.disabled,
      value = _ref.value;
  return _react.default.createElement(_.FlexContainer, {
    style: {
      margin: '0px 0px 1rem',
      justifyContent: 'center'
    }
  }, _react.default.createElement(_Button.default, {
    disabled: disabled,
    value: value,
    onClick: function onClick() {
      return buttonClickHandler();
    },
    fixDimension: {
      width: '100%'
    }
  }));
};

var _default = _react.default.memo(formButton);

exports.default = _default;